module.exports = __webpack_public_path__ + "static/media/block_icon_audio.663a40f8.svg";